import axios from 'axios';

const apiLapidar = axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': 'pt-BR',
    'X-Frame-Options': 'SAMEORIGIN',
    'Cache-Control': 'no-cache',
    'Strict-Transport-Security': 'max-age=31536000',
    'credentials': 'same-origin',
    'Expect-CT': 'max-age=86400',
    'Content-Security-Policy': 'connect-src "none"',
    client_id: process.env.REACT_APP_CLIENT_ID,
  },
  baseURL: process.env.REACT_APP_GETMORE,
});

async function refreshToken(error) {
  const refresh_token = localStorage.getItem('refresh_token');
  const header = {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };
  const parameters = {
    method: 'POST',
    headers: header,
  };
  const body = {
    grant_type: 'refresh_token',
    refresh_token,
  };
  axios
    .post(
      process.env.REACT_APP_API_URL + '/residential/store/v1/users/authentications',
      body,
      parameters,
    )
    .then(res => {
      const response = res.data;
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('refresh_token', response.refresh_token);
      window.location.href = window.location.pathname + window.location.search;
    })
    .catch(err => {
      window.location.href = '/acessar?error';
      return Promise.reject(error);
    });
}

function successHandler(response) {
  return response;
}

async function errorHandler(error) {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 408) {
      return await refreshToken(error);
    } else {
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(error);
  }
}

apiLapidar.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error),
);

export default apiLapidar;
